// Core modules
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Third party modules
import * as _ from 'lodash';

// Application services
import { AuthenticationService } from './authentication.service';
import { ConfigService } from './config.service';
import { BaseHttpService } from './base-http.service';

/**
 * ATS service
 */
@Injectable()
export class ATSService extends BaseHttpService {

  /**
   * Life cycle method
   * @param http HttpClient
   * @param configService ConfigService
   * @param authenticationService Authentication Service
   */
  constructor(
    public http: HttpClient,
    public configService: ConfigService,
    public authenticationService: AuthenticationService
  ) {
    super(http);
  }

  checkClientCredentials(payload: any): any {
    return this.post('ats-check-client-credentials', payload);
  }

  updateClientCredentials(payload: any): any {
    return this.post('ats-update-client-credentials', payload);
  }

  testATSJob(sqsJobId: number): any {
    return this.get('ats-test-client', undefined, {sqsJobId});
  }

  scheduleATSJob(sqsJobId: number, scheduleInMins: number): any {
    const params: any = {
      sqsJobId,
      scheduleInMins
    };
    return this.get('ats-schedule-client', undefined, params);
  }

  getRecentApiCallLogs(sqsJobId: number, limit: number = 5): any {
    const params: any = {
      sqsJobId,
      limit
    };
    return this.get('api-call-logs/recent', undefined, params);
  }
}
